export const WEBSOCKET_TYPES = {
    POSTS_VIEWEDS: 'posts_vieweds',
    TRACKINGS: 'trackings',
    BENEFIT: 'benefit',
    BENEFIT_REDEEM: 'benefit_redeem',
}

export const PATH_ASSETS = 'assets'

export const INPUT_TYPE = {
    SINGLE_CHOICE: 22,
    SINGLE_CHOICE_IMAGE: 28,
    MULTIPLE_CHOICE: 23,
    MULTIPLE_CHOICE_IMAGE: 24,
    COMPLETE_BLANKS: 34,
}

export const TRACKINGS_TYPES = {
    CHECKIN: 'checkin',
    CHECKOUT: 'checkout',
    CLEAR_CACHE: 'clear_cache',
    NAVIGATE_FORM_STORE: 'navigate_form_store',
    NAVIGATE_STORE: 'navigate_store',
}
